import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu';
import styled from 'styled-components';

export const StyledSessionsListSection = styled.div`
  .subheading2 {
    display: block;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--text-color-50);
    margin-bottom: 10px;
  }

  .chat-list {
    list-style: none;
    padding: 0;
    margin: 0;
    color: var(--ink);
    font-size: 13px;
    line-height: 16px;
    font-weight: 500;
    margin-bottom: 12px;

    > li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 5px;
      position: relative;
      padding: 0 30px 0 0;
      margin: 0 0 6px;
      border-radius: 10px;
      background: var(--gray-50);
      border: 1px solid transparent;
      cursor: pointer;
      transition: all 0.15s ease;

      &:hover {
        background: var(--primary-50);
        border-color: rgba(10, 77, 162, 0.15);
      }

      > .text {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex-grow: 1;
        padding: 10px 0 10px 10px;
      }
    }

    .action-btn {
      position: absolute;
      top: 52%;
      right: 5px;
      transform: translateY(-50%);
      font-size: 20px;
      line-height: 1;
      color: var(--ink);
      cursor: pointer;
    }
  }

  .float-dropdown {
    width: 100px;
    position: absolute;
    top: 6px;
    right: 22px;
    padding: 6px 10px;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    background: var(--white);

    .list {
      list-style: none;
      margin: 0;
      padding: 0;
      font-size: 14px;
      line-height: 18px;
      font-weight: 600;
      text-transform: capitalize;

      li {
        display: block;
        padding: 3px 0;
      }

      button {
        padding: 0;
        background: none;
      }
    }
  }
`;

export const MainMenu = styled(Menu)`
  &.szh-menu-container {
    left: 0 !important;
    right: 0 !important;
  }
  .szh-menu {
    left: auto !important;
    right: 0 !important;
    z-index: 10 !important;
  }
  ul {
    width: 120px;
    padding: 8px;
    border-radius: 12px;
    border: 1px solid rgba(157, 157, 157, 0.4);
  }
`;
export const MenuBtn = styled(MenuButton)`
  color: var(--ink);
  position: absolute;
  right: 10px;
  top: 10px;
`;
export const StyledMenuItem = styled(MenuItem)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 5px;
  border-radius: 5px;

  &.active,
  &:hover {
    background: rgba(241, 241, 241, 1);
  }

  &:last-child {
    margin: 0;
  }
`;
